// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__m9rj6","text":"Input_text__OSXFe","btn":"Input_btn__s6f49"};